import { Sprout, Repeat, Users, CircleDot, RotateCcw } from 'lucide-react'
import { BlurFade } from '@/components/ui/blur-fade'

const BELIEFS = [
  {
    Icon: Sprout,
    title: 'Curated with care',
    body: 'We’d rather point you to a few things worth your time than list everything. Every facilitator and space here is one we’d recommend to a friend.',
  },
  {
    Icon: Repeat,
    title: 'Practice over events',
    body: 'A single session is a beginning. What matters is the rhythm you build in the weeks after it.',
  },
  {
    Icon: Users,
    title: 'Held by people',
    body: 'The practices that last tend to happen in relationship — with a facilitator, a circle, a community that knows your name.',
  },
  {
    Icon: CircleDot,
    title: 'Wellbeing is whole',
    body: 'Physical, emotional, mental, social, spiritual, creative. We don’t treat these as separate things.',
  },
  {
    Icon: RotateCcw,
    title: 'Made for returning',
    body: 'Daily resets, recurring classes, and check-ins exist so you can come back — not just visit once.',
  },
]

export function HowWeThinkSection() {
  return (
    <section className="bg-primary-50/60">
      <div className="mx-auto max-w-[1100px] px-6 py-16 lg:px-20 lg:py-20">
        <BlurFade>
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            How we think about wellness
          </h2>
        </BlurFade>

        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {BELIEFS.map(({ Icon, title, body }, i) => (
            <BlurFade key={title} delay={i * 0.05}>
              <div className="h-full rounded-2xl border border-primary-100 bg-white p-6">
                <Icon className="h-8 w-8 text-primary-600" strokeWidth={1.5} />
                <h3 className="mt-4 text-lg font-semibold text-gray-900">
                  {title}
                </h3>
                <p className="mt-2 leading-relaxed text-gray-700">{body}</p>
              </div>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  )
}
